import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/info/mobile-joystick.png'
import _imports_1 from '@/assets/img/info/mobile-jump.png'
import _imports_2 from '@/assets/img/campaign/parts/campaign_new.png'


const _withScopeId = n => (_pushScopeId("data-v-7480588a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-controller" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "joystick",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jump",
  src: _imports_1
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "swiper-container" }
const _hoisted_6 = {
  key: 0,
  class: "campaign-banner"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "title"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "custom"
}
const _hoisted_14 = { class: "white-container" }
const _hoisted_15 = { class: "checkbox" }
const _hoisted_16 = {
  key: 2,
  class: "bottom custom-bottom"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "warning-message" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 4,
  class: "arrow pav1"
}
const _hoisted_22 = {
  key: 5,
  class: "arrow pav3"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_park_header = _resolveComponent("park-header")!
  const _component_CampaignTerms = _resolveComponent("CampaignTerms")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_navi = _resolveComponent("swiper-navi")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_chara_control = _resolveComponent("chara-control")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass({ tutorial: _ctx.step === 0 }),
    ref: "main"
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_4, 512), [
      [_vShow, _ctx.mobile]
    ]),
    _createVNode(_component_park_header, {
      ref: "menuComponent",
      demo: true
    }, null, 512),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isCampaignStep)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_swiper, { onSlideChange: _ctx.onSlideChange }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: index,
              class: _normalizeClass({ active: index === 0 })
            }, {
              default: _withCtx(() => [
                (content.icon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: require(`@/assets/img/info/${content.icon}`)
                      }, null, 8, _hoisted_10),
                      _createTextVNode(" " + _toDisplayString(content.title), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(content.title), 1)),
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: require(`@/assets/img/info/${content.image}`)
                  }, null, 8, _hoisted_12),
                  (content.custom)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_CampaignTerms, {
                            "is-new-member": true,
                            "force-open": true
                          }),
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.applyCheck) = $event)),
                              type: "checkbox",
                              id: "accept"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.applyCheck]
                            ]),
                            _createElementVNode("label", {
                              for: "accept",
                              class: _normalizeClass({ accept: _ctx.applyCheck })
                            }, "同意する", 2)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (content.custom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_ctx.canApply)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["apply-button", { accept: _ctx.applyCheck }]),
                            disabled: !_ctx.applyCheck,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
                          }, null, 10, _hoisted_17))
                        : (_openBlock(), _createElementBlock("p", _hoisted_18, "応募が完了しました。")),
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.applyMessage), 1)
                    ]))
                  : (content.text)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 3,
                        class: "bottom",
                        innerHTML: content.text
                      }, null, 8, _hoisted_20))
                    : _createCommentVNode("", true),
                (content.arrow === 'pavilion1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                  : _createCommentVNode("", true),
                (content.arrow === 'pavilion3')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                  : _createCommentVNode("", true),
                (_ctx.isLast)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 6,
                      class: _normalizeClass([{ mobile: _ctx.mobile }, "return"]),
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/info/info_30_button.png')
                      }, null, 8, _hoisted_23)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128)),
          (_ctx.step > 0)
            ? (_openBlock(), _createBlock(_component_swiper_navi, {
                key: 0,
                ref: "prevButton",
                isNext: false,
                onSwipe: _ctx.prev,
                class: "prev"
              }, null, 8, ["onSwipe"]))
            : _createCommentVNode("", true),
          (!_ctx.isLast)
            ? (_openBlock(), _createBlock(_component_swiper_navi, {
                key: 1,
                ref: "nextButton",
                isNext: true,
                onSwipe: _ctx.next,
                onEnd: _ctx.enter,
                class: _normalizeClass(["next", { first: _ctx.step === 0 }])
              }, null, 8, ["onSwipe", "onEnd", "class"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSlideChange"]),
      _createElementVNode("button", {
        class: "skip",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)))
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([`${_ctx.contents[_ctx.step].arrow}`, "arrow"]),
      ref: "arrow"
    }, null, 2),
    _createVNode(_component_chara_control, {
      demo: true,
      ref: "controlComponent"
    }, null, 512),
    _createElementVNode("div", {
      class: _normalizeClass([{ open: _ctx.contents[_ctx.step].control === 'menu-open' }, "menu-image"])
    }, [
      _createElementVNode("img", {
        src: require('@/assets/img/info/info_16_menu.png')
      }, null, 8, _hoisted_24)
    ], 2)
  ], 2))
}